<template>
  <div :class="classes" :style="styles">
    <div ref="wrapper" class="trbo-a-animation-height__wrapper">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    useOpacity: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      height: 0,
      isLoaded: false
    }
  },
  computed: {
    classes () {
      return {
        'trbo-a-animation-height': true,
        'trbo-a-animation-height--is-loaded': this.isLoaded,
        'trbo-a-animation-height--is-visible': this.isVisible,
        'trbo-a-animation-height--use-opacity': this.useOpacity
      }
    },
    styles () {
      return {
        '--final-height': `${this.height}px`
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.setHeight()
    })
  },
  methods: {
    setHeight () {
      this.height = this.$refs.wrapper.offsetHeight
      this.isLoaded = true
    }
  }
}
</script>

<style scoped src="./animation-height.scss" />
